import { SeriesFunction } from '../..';
import { IndexSeries } from '../../../DataSeries';


function extendIndices({series = null, steps = 1}) {
  let output = [];
  let values = Array.isArray(series) ? series.getValues() : [series];

  let startLength = values.length;
  let lastValue = values[startLength-1];

  for (let i = 0; i < startLength+steps; i++) {
    let v = (i >= startLength) ? lastValue : values[i];
    output.push([i, v]);
  }

  return new IndexSeries(output);
}

export const extendIndex = new SeriesFunction(
  extendIndices,
  {
    label: 'Extend a Series by Index',
    parameters: [
      {'name': 'series', 'type': 'series'},
      {'name': 'steps', 'type': 'number'}
    ]
  }
);